<script lang="ts" setup>
import { i18n } from '@/i18n';
import TableHead from '../TableHead.vue';
import { TableContentProperty } from '../../interface/tableContentHeaders';
import ArrowIcon from '../../components/ArrowIcon.vue';
import { ForecastForReceiptTableContentViewModel } from './forecastForReceiptTableContentViewModel';
import { IYearMonth } from '@/coreDomainsModule/date';
import { computed } from 'vue';
// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    forecastStartYearMonth?: IYearMonth;
  }>(),
  {
    forecastStartYearMonth: undefined,
  }
);
const forecastForReceiptTableContentVM = new ForecastForReceiptTableContentViewModel();
// emits
const emits = defineEmits<{
  (e: 'onClickSort', index: number, key: TableContentProperty, isAsc: boolean): void;
  (e: 'onMousedownResizer', event: MouseEvent, headerIndex: number): void;
}>();
//変数
const t = i18n.t;

const headerText = computed(() => {
  if (props.header.displayLabel) {
    return t(props.header.displayLabel);
  }
  return t(forecastForReceiptTableContentVM.getHeaderText(props.header.key, props.forecastStartYearMonth));
});
</script>

<template>
  <TableHead
    :class="[forecastForReceiptTableContentVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: forecastForReceiptTableContentVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    :index="headerIndex"
    :text-align="
      header.key === 'ForecastForReceiptRecoverStatus' && !header.displayLabel
        ? 'center'
        : header.key === 'ForecastForReceiptRowMenu' || header.key === 'ForecastForReceiptEditOption'
        ? 'right'
        : 'left'
    "
    :resizable="
      // 幅可変な列 && 固定する列に含まれていない -> 可変幅
      header.isVariableWidth && !forecastForReceiptTableContentVM.isSticky(stableColumnCount, headerIndex)
    "
    @on-mousedown-resizer="($event) => emits('onMousedownResizer', $event, headerIndex)"
  >
    <template v-if="header.sortOption.isSortable">
      <div class="table-header__sortable-content">
        <div class="table-header__text">{{ headerText }}</div>
        <ArrowIcon :asc="header.sortOption.isAsc" @on-click="emits('onClickSort', headerIndex, header, header.sortOption.isAsc)" />
      </div>
    </template>
    <template v-else>
      <div class="table-header__text">{{ headerText }}</div>
    </template>
  </TableHead>
</template>

<style scoped lang="scss"></style>
